import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { CommonActions } from "@react-navigation/routers";
import * as React from "react";
import NavigationContext from "./NavigationContext";
import { PrivateValueStore } from "./types";
import UnhandledActionContext from "./UnhandledActionContext";
// This is to make TypeScript compiler happy
// eslint-disable-next-line babel/no-unused-expressions
PrivateValueStore;
/**
 * Navigation object with helper methods to be used by a navigator.
 * This object includes methods for common actions as well as methods the parent screen's navigation object.
 */ export default function useNavigationHelpers(param) {
    var navigatorId = param.id, onAction = param.onAction, getState = param.getState, emitter = param.emitter, router = param.router;
    var onUnhandledAction = React.useContext(UnhandledActionContext);
    var parentNavigationHelpers = React.useContext(NavigationContext);
    return React.useMemo(function() {
        var dispatch = function(op) {
            var action = typeof op === "function" ? op(getState()) : op;
            var handled = onAction(action);
            if (!handled) {
                onUnhandledAction === null || onUnhandledAction === void 0 ? void 0 : onUnhandledAction(action);
            }
        };
        var actions = _object_spread({}, router.actionCreators, CommonActions);
        var helpers = Object.keys(actions).reduce(function(acc, name) {
            var _actions;
            // @ts-expect-error: name is a valid key, but TypeScript is dumb
            acc[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return dispatch((_actions = actions)[name].apply(_actions, _to_consumable_array(args)));
            };
            return acc;
        }, {});
        var navigationHelpers = _object_spread_props(_object_spread({}, parentNavigationHelpers, helpers), {
            dispatch: dispatch,
            emit: emitter.emit,
            isFocused: parentNavigationHelpers ? parentNavigationHelpers.isFocused : function() {
                return true;
            },
            canGoBack: function() {
                var state = getState();
                return router.getStateForAction(state, CommonActions.goBack(), {
                    routeNames: state.routeNames,
                    routeParamList: {},
                    routeGetIdList: {}
                }) !== null || (parentNavigationHelpers === null || parentNavigationHelpers === void 0 ? void 0 : parentNavigationHelpers.canGoBack()) || false;
            },
            getId: function() {
                return navigatorId;
            },
            getParent: function(id) {
                if (id !== undefined) {
                    var current = navigationHelpers;
                    while(current && id !== current.getId()){
                        current = current.getParent();
                    }
                    return current;
                }
                return parentNavigationHelpers;
            },
            getState: getState
        });
        return navigationHelpers;
    }, [
        navigatorId,
        emitter.emit,
        getState,
        onAction,
        onUnhandledAction,
        parentNavigationHelpers,
        router
    ]);
}
